// Client-side text extraction for course knowledge.
// txt/md direct · DOCX via mammoth · PDF via pdfjs-dist page walk.
export async function extractFileText(file: File): Promise<string | null> {
  const name = file.name.toLowerCase()
  try {
    if (file.type.startsWith('text/') || name.endsWith('.txt') || name.endsWith('.md')) {
      return await file.text()
    }
    if (name.endsWith('.docx')) {
      const mammoth: any = await import('mammoth/mammoth.browser')
      const { value } = await mammoth.extractRawText({ arrayBuffer: await file.arrayBuffer() })
      return value?.trim() || null
    }
    if (file.type === 'application/pdf' || name.endsWith('.pdf')) {
      const pdfjs: any = await import('pdfjs-dist')
      const workerUrl = (await import('pdfjs-dist/build/pdf.worker.min.mjs?url')).default
      pdfjs.GlobalWorkerOptions.workerSrc = workerUrl
      const doc = await pdfjs.getDocument({ data: await file.arrayBuffer() }).promise
      let out = ''
      for (let i = 1; i <= doc.numPages; i++) {
        const page = await doc.getPage(i)
        const tc = await page.getTextContent()
        out += tc.items.map((it: any) => it.str).join(' ') + '\n'
      }
      return out.trim() || null
    }
  } catch (e) {
    console.warn('[extractFileText] failed:', e)
  }
  return null
}